import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EmojiNeutral3dSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g filter={`url(#${_uniqueId}filter0_i_8745_56)`} suppressHydrationWarning>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 1.333C3.166 1.333 1.333 3.167 1.333 16S3.166 30.667 16 30.667 30.666 28.833 30.666 16 28.833 1.333 16 1.333m-4 20.134v2.4h8v-2.4zm11.333-7.6H18v-2.4h5.333zm-14.667 0H14v-2.4H8.666z"
                    fill={`url(#${_uniqueId}paint0_radial_8745_56)`}
                    suppressHydrationWarning
                />
                <path
                    d="M14 13.867H8.666v-2.4H14z"
                    fill={`url(#${_uniqueId}paint1_radial_8745_56)`}
                    suppressHydrationWarning
                />
                <path
                    d="M18 13.867h5.333v-2.4H18z"
                    fill={`url(#${_uniqueId}paint2_radial_8745_56)`}
                    suppressHydrationWarning
                />
                <path
                    d="M12 23.867v-2.4h8v2.4z"
                    fill={`url(#${_uniqueId}paint3_radial_8745_56)`}
                    suppressHydrationWarning
                />
            </g>
            <path d="M14 13.867H8.667v-2.4H14z" fill="#79610C" />
            <path d="M18 13.867h5.334v-2.4H18z" fill="#79610C" />
            <path d="M12 23.867v-2.4h8v2.4z" fill="#79610C" />
            <defs>
                <filter
                    id={`${_uniqueId}filter0_i_8745_56`}
                    x={1.333}
                    y={-3.667}
                    width={34.333}
                    height={34.333}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={5} dy={-5} />
                    <feGaussianBlur stdDeviation={5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8745_56" />
                </filter>
                <radialGradient
                    id={`${_uniqueId}paint0_radial_8745_56`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2789 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint1_radial_8745_56`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2789 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint2_radial_8745_56`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2789 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
                <radialGradient
                    id={`${_uniqueId}paint3_radial_8745_56`}
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(22.2789 6.83325) rotate(127.875) scale(26.129)"
                    suppressHydrationWarning
                >
                    <stop stopColor="#F9E193" />
                    <stop offset={1} stopColor="#FF9900" />
                </radialGradient>
            </defs>
        </svg>
    );
});
EmojiNeutral3dSize32Glyph.displayName = 'EmojiNeutral3dSize32Glyph';
